var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient-0",
    x1: 11.834,
    y1: 0,
    x2: 395.266,
    y2: 395.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb2553",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb2553",
    stopOpacity: 0.14
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient-0)",
    d: "M0 0h400v400h-400Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M400 270l-130 130h130Z",
    fill: "#eb2553"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M361.504 341.375c-1.71 0-3.096 1.386-3.096 3.096v13.932h-13.937c-1.71 0-3.096 1.387-3.096 3.096c0 1.71 1.386 3.097 3.096 3.097h13.937v13.933c0 1.71 1.386 3.096 3.096 3.096c1.71 0 3.097-1.386 3.097-3.096v-13.933h13.928c1.71 0 3.096-1.387 3.096-3.097c0-1.709-1.386-3.096-3.096-3.096h-13.928v-13.932c0-1.71-1.387-3.096-3.097-3.096Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.f09125267e7369d9c313d339913f35d5.svg";
export { ForwardRef as ReactComponent };